/* @ngInject */
function EmptyListMessageController ($state) {
  var ctrl = this

  ctrl.goTo = function (state) {
    $state.go(state)
  }
}

export { EmptyListMessageController }
